import React, { useState } from "react";
import { Plus, Flame } from "lucide-react";
import { useCart } from "../context/CartContext";

export default function ProductCard({ product }) {
  const { add } = useCart();
  const [selectedVariant, setSelectedVariant] = useState(product.variants?.[0] || null);

  const displayPrice = product.price + (selectedVariant?.delta || 0);

  return (
    <article
      className="bg-white border border-gray-100 rounded-2xl overflow-hidden transition-all hover:-translate-y-0.5 hover:shadow-[0_8px_24px_rgba(0,0,0,0.08)]"
      data-testid={`product-${product.id}`}
    >
      <div className="relative aspect-[4/3] bg-gray-100 overflow-hidden">
        <img
          src={product.image}
          alt={product.name}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
        />
        {product.popular && (
          <span className="absolute top-3 left-3 bg-black text-white text-[10px] uppercase tracking-widest font-bold px-2.5 py-1 rounded-full">
            Popular
          </span>
        )}
        {product.spicy && (
          <span className="absolute top-3 right-3 bg-[#C85A5A] text-white text-xs font-bold px-2 py-1 rounded-full inline-flex items-center gap-1">
            <Flame className="w-3 h-3" /> Spicy
          </span>
        )}
      </div>
      <div className="p-4 md:p-5">
        <h3 className="font-display font-bold text-lg leading-tight">{product.name}</h3>
        <p className="text-sm text-gray-500 mt-1 line-clamp-2 min-h-[2.5rem]">{product.description}</p>

        {product.variants?.length > 0 && (
          <div className="flex flex-wrap gap-1.5 mt-3">
            {product.variants.map((v) => (
              <button
                key={v.label}
                onClick={() => setSelectedVariant(v)}
                className={`text-xs px-3 py-1 rounded-full border transition ${selectedVariant?.label === v.label ? "bg-black text-white border-black" : "border-gray-200 text-gray-600 hover:border-black"}`}
                data-testid={`variant-${product.id}-${v.label}`}
              >
                {v.label}
                {v.delta ? <span className="ml-1 opacity-70">+₹{v.delta}</span> : null}
              </button>
            ))}
          </div>
        )}

        <div className="mt-4 flex items-center justify-between">
          <div className="font-display font-black text-xl">₹{displayPrice}</div>
          <button
            onClick={() => add(product, selectedVariant)}
            disabled={!product.available}
            className="bg-black text-white rounded-full px-4 py-2 text-sm font-bold inline-flex items-center gap-1.5 hover:bg-gray-800 active:scale-[0.98] transition disabled:bg-gray-300"
            data-testid={`add-${product.id}`}
          >
            <Plus className="w-4 h-4" />
            Add
          </button>
        </div>
      </div>
    </article>
  );
}
